import {
  AjaxCampsitePhotosRepository,
  AjaxResponse,
} from '~/common/photos/AjaxCampsitePhotosRepository'
import { emptyPhoto } from './emptyPhoto'
import { CampsitesPhotoGallery, PitchupPhoto } from './types'

interface SearchCampsitePhotos {
  general: PitchupPhoto[]
}

function getCampsitePhotos(
  photos: SearchCampsitePhotos | undefined,
): PitchupPhoto[] {
  if (!photos) {
    return [emptyPhoto]
  }
  return photos.general
}

export class PhotoLoaderService {
  async loadPhotoData(
    campsiteId: string,
    locale: string,
  ): Promise<CampsitesPhotoGallery> {
    const repository = new AjaxCampsitePhotosRepository()
    const url = repository.getAjaxUrl(locale, [campsiteId])
    const results = await $fetch<AjaxResponse>(url)
    const photos = repository.mapResults(results)
    return photos
  }

  async loadPhotos(
    campsiteId: string,
    locale: string,
  ): Promise<PitchupPhoto[]> {
    const photos = await this.loadPhotoData(campsiteId, locale)
    return getCampsitePhotos(photos[campsiteId]) || []
  }

  async loadAlbumsPhotos(
    campsiteId: string,
    locale: string,
  ): Promise<CampsitesPhotoGallery> {
    const photos = await this.loadPhotoData(campsiteId, locale)
    return photos
  }
}
